import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { CookieConsentModal } from './CookieConsentModal';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { Cookie, Settings, X } from 'lucide-react';

export const CookieBanner = () => {
  const { showBanner, acceptAll, acceptEssential, hideBanner } = useCookieConsent();
  const [showModal, setShowModal] = useState(false);

  if (!showBanner) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur-sm border-t">
        <Card className="max-w-6xl mx-auto">
          <CardContent className="p-4 sm:p-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="flex items-center gap-3 flex-1">
                <Cookie className="h-6 w-6 text-primary flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="font-semibold text-foreground mb-1">
                    Wir verwenden Cookies
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung zu bieten. 
                    Essenzielle Cookies sind für die Grundfunktionen erforderlich. Andere helfen uns, 
                    die Seite zu verbessern und relevante Inhalte anzuzeigen.
                  </p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setShowModal(true)}
                  className="flex items-center gap-2"
                >
                  <Settings className="h-4 w-4" />
                  Einstellungen
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={acceptEssential}
                >
                  Nur Essenzielle
                </Button>
                <Button
                  size="sm"
                  onClick={acceptAll}
                  className="bg-primary hover:bg-primary/90"
                >
                  Alle akzeptieren
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={hideBanner}
                  className="p-2"
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Dialog open={showModal} onOpenChange={setShowModal}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Cookie className="h-5 w-5 text-primary" />
              Cookie-Einstellungen
            </DialogTitle>
          </DialogHeader>
          <CookieConsentModal onClose={() => setShowModal(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};